import axios from "axios";

export default axios.create({
    baseURL: 'https://mikta.cyclic.app',
    withCredentials: true
});
